import React, { useId } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';
import voicesMedia from './voicesMedia.json';
import './voices-customer-marks.css';

export default function VoicesCustomerMarks() {
  const id = useId();
  return <section className="v-clients v-section v-customer-marks" id="our-customers" aria-labelledby={`${id}-title`} data-voices-theme="light">
    <div className="v-section-heading"><div><p className="v-label">Our customers</p><h2 id={`${id}-title`}>In good company.</h2></div><p>Recognisable names.<br />Real relationships.</p></div>
    <div className="v-logo-grid">{voicesMedia.logos.map(logo => <div key={logo.src}>{logo.story
      ? <Link to={logo.story} aria-label={`${logo.name} customer story`}><img src={logo.src} alt={logo.name} width={logo.width} height={logo.height} loading="lazy" decoding="async" /></Link>
      : <img src={logo.src} alt={logo.name} width={logo.width} height={logo.height} loading="lazy" decoding="async" />}</div>)}</div>
    <div className="vh-client-bottom"><p>A selection of customer relationships across our service portfolio.</p><Link className="v-text-link" to="/work">Explore customer stories <FiArrowUpRight aria-hidden="true" /></Link></div>
  </section>;
}
